<template>
  <div>
    <BubblesHeader
      v-for="node of nodes"
      :id="node.name"
      :key="node.path.toString()"
      :details="node"
    />
  </div>
</template>

<script lang="ts">

import Component from 'vue-class-component'

import HeadersAndHandlesMixin from '@/components/public/Bubbles/HeadersAndHandlesMixin'
import BubblesHeader from '@/components/public/Bubbles/Headers/BubblesHeader.vue'

const components = {
  BubblesHeader,
}

@Component({ components })
export default class BubblesHeaders extends HeadersAndHandlesMixin {
}

</script>
